module.exports = __webpack_public_path__ + "img/paket.0e0f37ee.png";